import {
  useReconciliationRunList as useReconciliationRunListQuery,
  useReconciliationRunGet as useReconciliationRunGetQuery,
  type ReconciliationRunSurfaceDto,
} from '../../../api/generated/client';
import { ROUTE_IDS, OPERATION_IDS } from '@finance/contracts';
import type { ListHookResult, GetHookResult, ResourceHookBinding } from '../../resource-hook-registry.js';
import { selectApiData, type ApiSuccessEnvelope } from '../../../api/select-api-data.js';

function selectReconciliationRunListRows(response: unknown): ReconciliationRunSurfaceDto[] {
  return selectApiData(response as ApiSuccessEnvelope<ReconciliationRunSurfaceDto[]>) ?? [];
}

function selectReconciliationRunDetail(response: unknown): ReconciliationRunSurfaceDto {
  return selectApiData(response as ApiSuccessEnvelope<ReconciliationRunSurfaceDto>);
}

export function useReconciliationRunList(): ListHookResult<ReconciliationRunSurfaceDto[]> {
  return useReconciliationRunListQuery({ query: { select: selectReconciliationRunListRows } });
}

export function useReconciliationRunGet(id: string): GetHookResult<ReconciliationRunSurfaceDto> {
  return useReconciliationRunGetQuery(id, { query: { select: selectReconciliationRunDetail } });
}

export const RECONCILIATION_RUNS_HOOKS: ResourceHookBinding<ReconciliationRunSurfaceDto[], ReconciliationRunSurfaceDto> = {
  useList: useReconciliationRunList,
  selectList: selectReconciliationRunListRows,
  useGet: useReconciliationRunGet,
  selectDetail: selectReconciliationRunDetail,
  rowIdExtractor: (row) => (typeof row.runId === 'string' ? row.runId : undefined),
  rowIdField: 'runId',
  routeParameterName: 'runId',
  paramName: 'runId',
  listRouteId: ROUTE_IDS.DATA_RECONCILIATION,
  detailRouteId: ROUTE_IDS.DATA_RECONCILIATION_DETAIL,
  readOperationId: OPERATION_IDS.RECONCILIATION_GET,
  detailDescriptorId: 'detail.reconciliationRuns',
};
